import { render } from "./brand_detail.vue?vue&type=template&id=746c43b2"
import script from "./brand_detail.vue?vue&type=script&lang=js"
export * from "./brand_detail.vue?vue&type=script&lang=js"

import "./brand_detail.vue?vue&type=style&index=0&id=746c43b2&lang=css"

import exportComponent from "C:\\Sunshine\\code\\zydt\\独立部署版\\ywym\\ydd-zht-api\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__